import { t } from '../../i18n'
import { VersionRowBase, VersionStatus, VersioningBase } from '../shared/versioning/types'
export interface ServoMove {
  id?: number | null
  position: number
  velocity: number
  acceleration: number
  deceleration: number
  pause_time: number
  step_number: number
  _destroy?: boolean
}

export type MoveStepType = 'cooking_mode' | 'unload_mode'

export type StepStatus = VersionStatus

export const syncBadge = (synced: boolean | null | undefined) =>
  synced === null || synced === undefined
    ? null
    : {
        label: t(synced ? 'servo_move_steps.synced' : 'servo_move_steps.not_synced'),
        variant: synced ? 'success-outline' : 'danger-soft'
      }

export interface ServoMoveStep {
  id?: number | null
  move_step_type: MoveStepType
  name?: string
  number_of_moves?: number
  status?: StepStatus
  version_number?: number
  synced_with_robot?: boolean | null
  servo_moves: ServoMove[]
}

export interface CopySourceServoMoveStep {
  id: number
  name: string
  version_number: number
  average_rating: number | null
  comments_count: number
  servo_moves: ServoMove[]
}

export interface VersionRow extends VersionRowBase {
  averageRating: number | null
  commentsCount: number
  syncedWithRobot: boolean | null
}

export interface VersioningProps extends VersioningBase<VersionRow> {
  usedByMoveModes: string[]
  affectedLocations: string[]
}

// Mirrors McpServer::Tools::Support::ServoSteps::EXPOSED_FIELDS
export const AI_SUGGESTION_FIELDS = [
  'position_mm',
  'velocity_m_s',
  'acceleration_m_s2',
  'deceleration_m_s2',
  'pause_time_ms'
] as const

export type AiSuggestionField = (typeof AI_SUGGESTION_FIELDS)[number]

export type AiSuggestionMove = { step_number: number } & Record<
  AiSuggestionField,
  number
>

export interface AiClampedValue {
  step_number: number
  field: AiSuggestionField
  requested: number
  applied: number
}

export interface AiSuggestion {
  draft_id: number
  draft_version: number
  reason: string
  affected_move_modes: string[]
  clamped_to_safe_limits: AiClampedValue[]
  before: AiSuggestionMove[]
  after: AiSuggestionMove[]
  conversation_id: string | null
}

export interface UsageMoveMode {
  move_mode_id: number
  move_mode_name: string
  recipe_count: number
  prepared_count: number
}

export interface ServoMoveStepUsage {
  move_mode_count: number
  prepared_count: number
  move_modes: UsageMoveMode[]
}
